import { SalesforceService } from './services/salesforce/salesforce.service.interface';
import { SalesforceServiceMock } from './services/salesforce/salesforce.service.mock';
import { SalesforceServiceReal } from './services/salesforce/salesforce.service.real';

export const provideSalesforceService = {
    provide: SalesforceService,
    useClass: SalesforceServiceReal,
};
